module.exports = __webpack_public_path__ + "media/images/emblems/Thonex-coat_of_arms-da0d6cf584a89b7f1b3e1b44d2b69be3.svg";